import { formValidationConstants } from '../components/utils/constants/form-validation-constants';
import { createDate, getTodayAsDate } from '../components/utils/date-utils';

export function validateDate(dateOfBirth) { 
    if (!dateOfBirth) {
        return { isValid: false, errorMessage: formValidationConstants.dateOfBirthErrorMessage };
    }

    if (Object.prototype.toString.call(dateOfBirth) === '[object Date]') {
        return { isValid: true };
    }

    const { day, month, year } = dateOfBirth;
    if ((!day && day != '') || (!month && month != '') || (!year && year!='')) {
        return { isValid: true };
    }
    const userSetDate = parseUserSetDate({ day, month, year });

    if (!userSetDate) {
        return { isValid: false, errorMessage: formValidationConstants.dateOfBirthErrorMessage };
    }

    if (isMonthValid(userSetDate.monthAsNumber)) {
        return { isValid: false, errorMessage: formValidationConstants.dateOfBirthErrorMessage };
    }

    if (isUserOfAge(userSetDate)) {
        return { isValid: false, errorMessage: formValidationConstants.membersMustBeOVer16 };
    }

    return {
        isValid: true
    };
}

function parseUserSetDate(userSetValues) {
    const dayAsNumber = userSetValues.day ? parseInt(userSetValues.day, 10) : NaN;
    const monthAsNumber = userSetValues.month ? parseInt(userSetValues.month, 10) : NaN;
    const yearAsNumber = userSetValues.year ? parseInt(userSetValues.year, 10) : NaN;   

    const areValuesInvalid = Number.isNaN(dayAsNumber) ||
        Number.isNaN(monthAsNumber) ||
        Number.isNaN(yearAsNumber);

    if (areValuesInvalid) {
        return null;
    }

    return { dayAsNumber, monthAsNumber, yearAsNumber };
}

function isMonthValid(monthAsNumber) {
    return monthAsNumber < formValidationConstants.minimumValidMonth ||
        monthAsNumber > formValidationConstants.maximumValidMonth;
}

function isUserOfAge(userSetDate) {
    const userBirthDate = createDate(userSetDate.yearAsNumber, userSetDate.monthAsNumber, userSetDate.dayAsNumber);
    const uerAge = getAge(userBirthDate);
    return uerAge < formValidationConstants.minimumValidAge;
}

function getAge(birthDate) {
    const today = getTodayAsDate();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}
